import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { fetchChangePasswordUrl, getChangePasswordDetails, changePassword } from '../../actions/login';
import { faEye, faEyeSlash, faTimes } from '@fortawesome/free-solid-svg-icons';
import styles from './Login.scss';
import PasswordValidation from './PasswordValidation';
import { getAuthCredentials } from '../../util/auth-storage';
import { checkValidPassword } from './CheckValidPassword';



const ChangePasswordModal = (props) => {
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [currentPasswordType, setCurrentPasswordType] = useState(true);
    const [newPasswordType, setNewPasswordType] = useState(true);
    const [passwordError, setPasswordError] = useState('');
    const [newPasswordError, setNewPasswordError] = useState('');
    const [validPassword, setValidPassword] = useState(false);
    const [changePasswordSession, setChangePasswordSession] = useState();
    const [invalidUrlError, setInvalidURlError] = useState('');
    const [changePasswordError, setChangePasswordError] = useState('');
    const { accessToken } = getAuthCredentials();

    useEffect(() => {
        const fetchData = async () => {
            try {
                let signInUrl = await fetchChangePasswordUrl(accessToken);
                // eslint-disable-next-line no-useless-escape
                signInUrl = signInUrl.provider_uri.replace(/^https?:\/\/[^\/]+\//, '') + '&api=true';
                const changePasswordDetails = await getChangePasswordDetails(signInUrl);
                setChangePasswordSession(changePasswordDetails.session);
            }
            catch (e) {
                setInvalidURlError('Something went wrong, please try again !');
            }
        };

        fetchData();
    }, []);

    const onSubmitClick = async (e) => {
        try {
            e.preventDefault();

            const isCurrentPasswordEmpty = currentPassword === '';
            const isNewPasswordEmpty = newPassword === '';
            const isNewPasswordInvalid = !validPassword || !checkValidPassword(newPassword);

            setPasswordError(isCurrentPasswordEmpty ? 'Please enter your current password.' : '');
            setNewPasswordError(isNewPasswordEmpty ? 'Please enter a valid password.' : '');
            setChangePasswordError('');

            if (isCurrentPasswordEmpty || isNewPasswordEmpty) {
                if (isCurrentPasswordEmpty && !isNewPasswordEmpty && isNewPasswordInvalid) {
                    setNewPasswordError('Your password does not meet our requirements.');
                }
                return;
            }

            if (isNewPasswordInvalid) {
                setNewPasswordError('Your password does not meet our requirements.');
                return;
            }

            const changeResponse = await props.changePassword({
                email: props.email,
                oldPassword: currentPassword,
                newPassword: newPassword,
                confirmPassword: newPassword,
                sessionId: changePasswordSession
            });
            if (changeResponse.error) {
                if (changeResponse.error === 'The password could not be changed.') {
                    setPasswordError('This password is incorrect. Please try again.');
                    setNewPasswordError('');
                }
                else {
                    setPasswordError('');
                    setNewPasswordError('');
                    setChangePasswordError(changeResponse.error.replace('Validation error: ', ''));
                }
            }
            if (changeResponse.code) {
                setCurrentPassword('');
                setNewPassword('');
                setPasswordError('');
                setNewPasswordError('');
                setChangePasswordError('');
                setNewPasswordType(true);
                setCurrentPasswordType(true);
                props.toggleModal();
            }
        }
        catch (e) {
            setPasswordError('');
            setNewPasswordError('');
            setChangePasswordError('Something went wrong. Please try again!');
        }
    };

    const closeModal = () => {
        setCurrentPassword('');
        setNewPassword('');
        setPasswordError('');
        setNewPasswordError('');
        setChangePasswordError('');
        setNewPasswordType(true);
        setCurrentPasswordType(true);
        props.toggleModal();
    };


    if (!props.isModalOpen) return null;
    if (invalidUrlError) {
        return (
            <div className={styles.invalidUrl}>
                <div className={styles.complionSubTitle} style={{ color: 'red' }}>{invalidUrlError}</div>
            </div>
        );
    }

    return (
        <div className={styles.modal}>
            <div className={styles.modalContent}>
                <div className={styles.modalHeader}>
                    <h2>Change Password</h2>
                    <FontAwesomeIcon
                        icon={faTimes}
                        className={styles.closeIcon}
                        onClick={closeModal}
                    />
                </div>
                <div className={styles.modalBody}>
                    <form autoComplete="off" className={styles.form} onSubmit={(e) => onSubmitClick(e)} noValidate>
                        <div className={styles.inputContainer}>
                            <div className={styles.formGroup}>
                                <div className={styles.labelGroup}>
                                    <label htmlFor="old-password" className={styles.inputLabelv4}>
                                        Current Password
                                    </label>
                                </div>

                                <label className={`${styles.passowordInput} ${passwordError && styles.passowordInputError}`}>
                                    <input
                                        id="old-password"
                                        name="currentPassword"
                                        type={currentPasswordType ? 'password' : 'text'}
                                        value={currentPassword}
                                        onChange={(e) => setCurrentPassword(e.target.value)}
                                        autoFocus
                                    />
                                    <FontAwesomeIcon
                                        icon={currentPasswordType ? faEye : faEyeSlash}
                                        className={styles.passwordIcon}
                                        onClick={() =>
                                            setCurrentPasswordType(!currentPasswordType)
                                        }
                                    />
                                </label>
                                {passwordError && <span className={styles.errorv4}>{passwordError}</span>}
                            </div>
                            <div className={styles.formGroup}>
                                <div className={styles.labelGroup}>
                                    <label htmlFor="password" className={styles.inputLabelv4}>
                                        New Password
                                    </label>
                                </div>
                                <label className={`${styles.passowordInput} ${newPasswordError && styles.passowordInputError}`}>
                                    <input
                                        id="new-password"
                                        type={newPasswordType ? 'password' : 'text'}
                                        name="password"
                                        value={newPassword}
                                        onChange={(e) => setNewPassword(e.target.value)}
                                    />
                                    <FontAwesomeIcon
                                        icon={newPasswordType ? faEye : faEyeSlash}
                                        className={styles.passwordIcon}
                                        onClick={() =>
                                            setNewPasswordType(!newPasswordType)
                                        }
                                    />
                                </label>
                                {newPasswordError && <span className={styles.errorv4}>{newPasswordError}</span>}
                                {changePasswordError && <span className={styles.errorv4}>{changePasswordError}</span>}
                                <PasswordValidation password={newPassword} setValidPassword={setValidPassword} />
                            </div>
                        </div>

                        <div className={styles.formGroup}>
                            <button type="submit" className={styles.actionButtonv4} >
                                Change Password
                            </button>
                        </div>
                    </form >
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, { changePassword })(withRouter(ChangePasswordModal));
